<div [formGroup]="parentForm">
  <custom-label  *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
  <p-editor [formControlName]="nameInput"  [(ngModel)]="ngValue" [style]="{ height: '220px' }"></p-editor>
</div>
